import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import AutomService from "../../../../services/AutomService/AutomService";
import MateService from "../../../../services/MateService/MateService";
import { useNavigate } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import Close from "@material-ui/icons/Close";
import { useSetRecoilState } from 'recoil';
import { alertState } from "../../../../recoil-store/recoil-state";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import QueuePoolService from "../../../../services/QueuePoolService/QueuePoolService";
import VariableService from '../../../../services/VariableService/VariableService';

const useStyles = makeStyles((theme) => ({
    input: {
        backgroundColor: "#fff",
        marginBottom: 20,

    },
    bottomSection: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    button: {
        border: "none",
        borderRadius: "5px",
        width: 100,
        height: 35,
        float: "right",
        "&:focus": {
            outline: "none",
        },
    },
    submit: {
        color: "white",
        marginLeft: 15,
        backgroundColor: "#079063",
        cursor: "pointer",
    },
    formLabelSemiColon: {
        position: "absolute",
        right: "0",
    },
    formLabel: {
        justifyContent: "left",
        alignItems: "center",
        display: "flex",
        position: "relative",
    },
}));

const AddNewAutom = (props) => {
    const history = useNavigate();
    const classes = useStyles();
    const { t } = useTranslation();
    const [typeList, setTypeList] = useState([]);
    const [mates, setMates] = useState([]);
    const [automName, setAutomName] = useState("");
    const [description, setDescription] = useState("");
    const [type, setType] = useState("");
    // const [integrationType, setIntegrationType] = useState("");
    const [queuePool, setSelectQueuePool] = useState("");
    const [queuePoolData, setQueuePoolData] = useState([]);
    const [selectedMate, setSelectedMate] = useState("");
    const [flowTimeOut, setFlowTimeOut] = useState(5000);
    // const [triggerType, setTriggerType] = useState({
    //     email: false,
    //     webhook: false,
    //     api: false,
    // });
    const [queueEnable, setQueueEnable] = useState(false);
    const handleClose = () => {
        props.setOpen(false);
    };
    const setAlert = useSetRecoilState(alertState);
    const GetListType = async () => {
        const response = await AutomService.getListType();
        if (response.status) {
            if (Array.isArray(response.data)) {
                setTypeList(response.data);
            }
        }
    };
    const GetMates = async () => {
        const response = await MateService.getAllMates();
        if (response?.status) {
            setMates(response.data);
            if (response.data.length > 0) {
                response.data.map((mate) => {
                    if (mate.is_default_device) {
                        setSelectedMate(mate.id);
                    }
                });
            }
        }
    };

    const GetQueuePools = async () => {
        const response = await QueuePoolService.getQueuePool();
        if (response.status) {
            setQueuePoolData(response.data);
        }
    }

    useEffect(() => {
        GetListType().then(r => r);
        GetMates().then(r => r);
        GetQueuePools().then(r => r)
    }, []);

    const handleChange = (event) => {
        setQueueEnable(event.target.checked ? 1 : 0);
    };

    //A new variable will be created when a new trigger flow added.
    async function automaticallyVariableCreation(autom_version_id) {
        const data = {
            name: "triggerParam",
            type: "object",
            type_id: "f1ff5b71-cf84-402b-b73c-eb4e399790b9",
            description: "",
            is_input: 0,
            is_output: 0,
            is_customizable: 0,
            autom_version_id
        };
        const { status } = await VariableService.postVariable(data);
        return status;
    }

    const onSubmit = async () => {
        if (automName.length > 0 && type.length > 0) {
            const mateId = selectedMate !== "" ? selectedMate : null;
            let newFormData = {
                name: automName,
                description: description,
                type_id: type,
                integration_type: 'STANDART',
                timeOut: flowTimeOut,
                mate_id: mateId,
                queue_enabled: queueEnable,
                qpool_id: queuePool
            };
            // if (integrationType === "TRIGGER") {
            //     let trigger_type = ''
            //     if (triggerType.email) {
            //         trigger_type = 'email'
            //     }
            //     if (triggerType.webhook) {
            //         trigger_type += `${trigger_type !== '' ? ',' : ''}webhook`
            //     }
            //     if (triggerType.api) {
            //         trigger_type += `${trigger_type === '' ? '' : ','}api`
            //     }
            //     newFormData = {
            //         ...newFormData,
            //         trigger_type
            //         // triggerType.email === true && triggerType.webhook
            //         //     ? "email,webhook"
            //         //     : triggerType.email === true
            //         //         ? "email"
            //         //         : "webhook",
            //     };
            // }
            // if (integrationType === "TRIGGER" && !triggerType.email && !triggerType.webhook && !triggerType.api) {
            //     setAlert(alert => ({
            //         ...alert,
            //         show: true,
            //         message: t("CONTENT.AUTOMS-LIST.TRIGGER-TYPE-REQUIRED"),
            //         severity: 'error'
            //     }));
            //     return;
            // }
            // Check if queue pool is selected or not
            if (queueEnable && queuePool?.length === 0) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("CONTENT.AUTOMS-LIST.QUEUE-POOL-REQUIRED"),
                    severity: 'error'
                }));
                return;
            }
            const response = await AutomService.postAutom(newFormData);
            if (response.status) {
                // if (triggerType.webhook || triggerType.api) {
                //     const result = await automaticallyVariableCreation(response.autom_version_id)
                //     if (!result) {
                //         setAlert(alert => ({
                //             ...alert,
                //             show: true,
                //             message: t("CONTENT.AUTOMS-LIST.TRIGGER-PARAM-CREATED-ERROR"),
                //             severity: 'error'
                //         }));
                //     }
                // }
                let typeName = typeList?.filter((item) => item.id === type);
                if (typeName.length > 0) {
                    history(`/automs/${response.id}/autom/edit`);
                } else {
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t("MESSAGES.AUTOMS.AUTOMS-ADDED-FAILED"),
                        severity: response.status ? 'success' : 'error'
                    }));
                }
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.AUTOMS." + response.message),
                    severity: 'error'
                }));
            }
        } else {
            if (type.length < 1) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.AUTOMS.AUTOM-TYPE-REQUIRED'),
                    severity: 'error'
                }));
            }
            if (automName.length < 1) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.AUTOMS.AUTOM-NAME-REQUIRED'),
                    severity: 'error'
                }));
            }
        }
    };

    // const handleIntegrationType = (event) => {
    //     let updatedData = {
    //         ...triggerType,
    //         [event.target.name]: event.target.checked
    //     }
    //     if (event.target.name === 'webhook' && event.target.checked) {
    //         updatedData.api = false
    //     } else if (event.target.name === 'api' && event.target.checked) {
    //         updatedData.webhook = false
    //     }

    //     setTriggerType(updatedData);
    // };
    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: 400,
                    padding: "8px 24px 8px 24px"
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    {t("CONTENT.AUTOMS-LIST.CREATE-NEW-AUTOM")}
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ textAlign: "left", marginTop: 20 }}>
                    <div className="form-element">
                        <div className="modal-text add-autom">
                            <div>{t("CONTENT.AUTOMS-LIST.AUTOM-NAME")}</div>
                        </div>
                        <TextField
                            id="filled-size-small"
                            autoFocus
                            style={{
                                float: "left",
                                backgroundColor: "#fff",
                                width: "100%",
                            }}
                            value={automName}
                            onChange={(e) => setAutomName(e.target.value)}
                            className={classes.input}
                            variant="outlined"
                            size="small"
                            inputProps={{ style: { fontSize: 12 } }}
                        />
                    </div>

                    <div className="form-element">
                        <div className="modal-text" style={{ marginBottom: 5 }}>{t("CONTENT.AUTOMS-LIST.TYPE")}</div>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                style={{
                                    backgroundColor: "#fff",
                                    height: "40px",
                                    fontSize: "12px",
                                }}
                                id="demo-simple-select-outlined"
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                            >
                                {typeList &&
                                    typeList?.map((item) => (
                                        <MenuItem
                                            style={{ fontSize: 12 }}
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="form-element add-autom-input">
                        <div className="modal-text">
                            {t("CONTENT.AUTOMS-LIST.DESCRIPTION")}
                        </div>
                        <TextField
                            id="filled-size-small"
                            style={{ float: "left" }}
                            className={classes.input}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            variant="outlined"
                            size="small"
                            multiline
                            rows={5}
                            fullWidth
                            inputProps={{ style: { fontSize: 12 } }}
                        />
                    </div>

                    <div className="form-element add-autom-input">
                        <div className="modal-text">Action Timeout(ms)</div>
                        <TextField
                            id="filled-size-small"
                            style={{ float: "left" }}
                            className={classes.input}
                            value={flowTimeOut}
                            onChange={(e) => setFlowTimeOut(e.target.value)}
                            variant="outlined"
                            size="small"
                            type="number"
                            fullWidth
                            inputProps={{ style: { fontSize: 12 } }}
                        />
                        {flowTimeOut < 2000 ? (
                            <small>Please enter over 2000 ms</small>
                        ) : null}
                    </div>

                    {/* <div className="form-element">
                        <div className="modal-text">
                            {t("CONTENT.AUTOMS-LIST.INTEGRATION-TYPE")}
                        </div>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                style={{
                                    backgroundColor: "#fff",
                                    height: "40px",
                                    fontSize: "12px",
                                }}
                                id="demo-simple-select-outlined"
                                value={integrationType}
                                onChange={(e) => setIntegrationType(e.target.value)}
                            >
                                <MenuItem style={{ fontSize: 12 }} value="STANDARD">
                                    {t("CONTENT.AUTOMS-LIST.STANDARD")}
                                </MenuItem>
                                <MenuItem style={{ fontSize: 12 }} value="SCHEDULE">
                                    {t("CONTENT.AUTOMS-LIST.SCHEDULE")}
                                </MenuItem>
                                <MenuItem style={{ fontSize: 12 }} value="TRIGGER">
                                    {t("CONTENT.AUTOMS-LIST.TRIGGER")}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    {integrationType === "TRIGGER" ? (
                        <>
                            <div className="form-element">
                                <div className="modal-text">
                                    {t("CONTENT.AUTOMS-LIST.TRIGGER-TYPE")}
                                </div>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={triggerType.email}
                                            onChange={handleIntegrationType}
                                            name="email"
                                            color="default"
                                            size="small"
                                        />
                                    }
                                    label="E-mail"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={triggerType.webhook}
                                            onChange={handleIntegrationType}
                                            name="webhook"
                                            color="default"
                                            size="small"
                                        />
                                    }
                                    label="Webhook"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={triggerType.api}
                                            onChange={handleIntegrationType}
                                            name="api"
                                            color="default"
                                            size="small"
                                        />
                                    }
                                    label="Api"
                                />
                            </div>
                        </>
                    ) : null} */}
                    <div className="form-element">
                        <div className="modal-text">Mate</div>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                style={{
                                    backgroundColor: "#fff",
                                    height: "40px",
                                    fontSize: "12px",
                                }}
                                id="demo-simple-select-outlined"
                                value={selectedMate}
                                onChange={(e) => setSelectedMate(e.target.value)}
                            >
                                {mates.length > 0 &&
                                    mates.map((mate) => (
                                        <MenuItem
                                            key={mate.id}
                                            style={{ fontSize: 12 }}
                                            value={mate.id}
                                        >
                                            {mate.device_name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="form-element">
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "100%" }}
                        >
                            <FormControlLabel

                                control={
                                    <Checkbox
                                        checked={queueEnable}
                                        size="small"
                                        color="#C4C4C4"
                                        inputName="queueEnable"
                                        onChange={handleChange}
                                    />

                                }
                                label={<div className="modal-text">{t("CONTENT.AUTOMS-LIST.QUEUE-ENABLED")}</div>}
                            />
                        </FormControl>
                    </div>
                    {queueEnable ?
                        <div className="form-element">
                            <div className="modal-text">{t("CONTENT.AUTOMS-LIST.RELATED-QUEUE-POOL")}</div>
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}
                                style={{ width: "100%" }}
                            >
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    style={{
                                        backgroundColor: "#fff",
                                        height: "40px",
                                        fontSize: "12px",
                                    }}
                                    id="demo-simple-select-outlined"
                                    value={queuePool}
                                    onChange={(e) => setSelectQueuePool(e.target.value)}
                                >
                                    {queuePoolData?.map(data => <MenuItem value={data.id}>{data.pool_name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </div>
                        : null}
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "center",
                    padding: "8px 24px 16px 24px",
                }}
            >
                <div className={classes.bottomSection}>
                    <button
                        type="button"
                        onClick={onSubmit}
                        data-test="createautom-button"
                        className={`${classes.button} ${classes.submit}`}
                        style={{
                            backgroundColor: "#162436",
                            borderRadius: "4px",
                            color: "#fff",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)"
                        }}
                    >
                        {t("CONTENT.AUTOMS-LIST.CREATE")}
                    </button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default AddNewAutom;
